/* cords2-combo.js - Often bought with follows the finish chosen above.
   15 October 2026, at Viktor's ask: the companions have to match the colour
   selected on the product.

   WHY THIS IS JAVASCRIPT AND NOT LIQUID. The right answer is Liquid: render
   each companion's finish-to-variant map into the row and the swap needs no
   network at all. That map does not fit. The rows are drawn by
   sections/cords2-pdp-buy.liquid, which is 15,352 characters against the
   Admin API's 16,384 limit for a whole GraphQL document, so there is room in
   that file for about one line and no room for the note explaining it.
   Nothing here requires touching it: the panel already renders everything
   needed to do this from the outside.

   WHAT IT READS, all of it already on the page:
     the finish picker   .c2-finish input[type=radio], value is the name
     the companion rows  .c2-combo__row
     each row's product  the /products/<handle> link inside it
     each row's variant  the cart form's hidden id input

   The cart form is a real form posting to /cart/add, so changing that hidden
   input is the whole job: Add then posts the matching finish with no other
   co-operation from the page, and the row still works with this script
   missing or failed.

   THE ROOT COMES FROM THE LINK, not from Shopify.routes. The store is
   multi-market and a product link may carry a locale prefix; slicing the
   root off the href the page already rendered gets that right without this
   file knowing anything about markets.

   WHAT HAPPENS WHEN A COMPANION HAS NO SUCH FINISH: nothing. The row is left
   exactly as it was rather than guessed at. A product with no colour option
   at all takes the same path.

   OTHER OPTIONS ARE PRESERVED. Extend E1 is sold in two lengths, so matching
   on colour alone would silently move someone from 3 metres to 2. The match
   keeps every non-colour option at the value the row is currently showing
   and only changes the colour.

   THE FETCH IS DEFERRED to idle. Three product JSON files is not much, but
   it is not worth anything during first paint either, and the first finish
   change re-runs it anyway.

   THE THUMBNAIL IS DECODED BEFORE IT IS PUT IN. 15 October 2026, with the
   gallery's flicker. Clearing srcset and assigning src is the only way to
   make src win, but it also drops what the element is showing, so three
   thumbnails went blank together and popped back as they arrived. The new
   picture is decoded off-screen and swapped in one frame; the old finish
   stays on screen until it is ready. A token drops a decode that a later
   finish has already overtaken. */
(function () {
  if (window.__c2ComboBound) return;
  window.__c2ComboBound = true;

  var rows = Array.prototype.slice.call(document.querySelectorAll('.c2-combo__row'));
  if (!rows.length) return;

  var radios = document.querySelectorAll('.c2-finish input[type="radio"]');
  if (!radios.length) return;

  var COLOUR = /^(colou?r|finish)$/i;
  var jobs = {};
  var token = 0;

  function chosen() {
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return radios[i].value;
    }
    return null;
  }

  /* the row's product, and the site root it was linked from */
  function parts(row) {
    var a = row.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var at = href.indexOf('/products/');
    if (at < 0) return null;
    var handle = href.slice(at + 10).split(/[?#]/)[0];
    if (!handle) return null;
    return { root: href.slice(0, at), handle: handle };
  }

  function load(p) {
    var key = p.root + '|' + p.handle;
    if (!jobs[key]) {
      jobs[key] = fetch(p.root + '/products/' + p.handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return jobs[key];
  }

  /* products.js has given options as plain strings and as objects with a
     name, depending on the API version the shop is on. Both are handled. */
  function colourIndex(prod) {
    var o = prod.options || [];
    for (var i = 0; i < o.length; i++) {
      var name = typeof o[i] === 'string' ? o[i] : (o[i] && o[i].name);
      if (name && COLOUR.test(String(name).trim())) return i;
    }
    return -1;
  }

  function pick(prod, want, currentId) {
    var ci = colourIndex(prod);
    if (ci < 0) return null;
    var vs = prod.variants || [];
    var cur = null, i;
    for (i = 0; i < vs.length; i++) {
      if (String(vs[i].id) === String(currentId)) cur = vs[i];
    }
    var hit = vs.filter(function (v) { return v.options[ci] === want; });
    if (!hit.length) return null;

    /* keep the length, or whatever else this product is sold by */
    if (cur) {
      var keep = hit.filter(function (v) {
        return v.options.every(function (o, n) { return n === ci || o === cur.options[n]; });
      });
      if (keep.length) hit = keep;
    }
    var free = hit.filter(function (v) { return v.available; });
    return { v: free[0] || hit[0], available: free.length > 0, name: want };
  }

  /* Rewrite the amount inside the row's existing price string rather than
     formatting one from scratch, so the currency, its position and the
     decimal mark stay whatever the market rendered. Thousands separators are
     not reconstructed; nothing in this range reaches four figures. If the
     string cannot be read, it is left alone: a stale price is worse than an
     unchanged one only when it is wrong, and it is only ever written when
     the new variant costs something different. */
  function reprice(text, cents) {
    var m = text.match(/\d[\d.,  ]*\d|\d/);
    if (!m) return null;
    var num = m[0];
    var sep = /[.,](\d{2})$/.exec(num);
    var major = Math.floor(cents / 100);
    var minor = cents % 100;
    var out = sep ? String(major) + sep[0].charAt(0) + ('0' + minor).slice(-2) : String(major);
    return text.replace(num, out);
  }

  function swapThumb(img, url, mine) {
    var pre = new Image();
    function put() {
      if (mine !== token) return;
      /* srcset would otherwise win over the src we are about to set */
      img.removeAttribute('srcset');
      img.setAttribute('src', url);
    }
    pre.src = url;
    if (pre.decode) { pre.decode().then(put, put); }
    else if (pre.complete) { put(); }
    else { pre.onload = put; pre.onerror = put; }
  }

  function apply(row, p, res, mine) {
    var v = res.v;
    var form = row.querySelector('form[action*="/cart/add"]');
    var id = form && form.querySelector('input[name="id"]');
    if (!id) return;
    if (String(id.value) === String(v.id)) return;

    id.value = v.id;

    var url = p.root + '/products/' + p.handle + '?variant=' + v.id;
    Array.prototype.forEach.call(row.querySelectorAll('a[href*="/products/"]'), function (a) {
      a.setAttribute('href', url);
    });

    var img = row.querySelector('.c2-combo__thumb img');
    var src = v.featured_image && v.featured_image.src;
    if (img && src) {
      swapThumb(img, src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160', mine);
    }

    var meta = row.querySelector('.c2-combo__meta span');
    if (meta && typeof v.price === 'number') {
      var t = reprice(meta.textContent, v.price);
      if (t && t !== meta.textContent) meta.textContent = t;
    }

    var btn = row.querySelector('.c2-combo__add');
    if (btn) {
      /* The finish is said in the label rather than added to the row, where a
         third clause on a 12px line in a 320px column is a wrap waiting to
         happen. The picture carries it visually. */
      if (!btn.getAttribute('data-c2-base')) {
        btn.setAttribute('data-c2-base', btn.getAttribute('aria-label') || '');
      }
      btn.setAttribute('aria-label', btn.getAttribute('data-c2-base') + ' in ' + res.name);
      btn.disabled = !res.available;
      /* Styled from here rather than from a stylesheet: the rule would live
         in cords2-pdp-panel.css, and this is one declaration against an 8 KB
         retype of that file. Move it there the next time it is opened. */
      btn.style.opacity = res.available ? '' : '0.4';
    }
  }

  function sync() {
    var want = chosen();
    if (!want) return;
    var mine = ++token;
    rows.forEach(function (row) {
      var p = parts(row);
      if (!p) return;
      var form = row.querySelector('form[action*="/cart/add"]');
      var id = form && form.querySelector('input[name="id"]');
      if (!id) return;
      load(p).then(function (prod) {
        if (!prod) return;
        /* the visitor may have chosen again while this was in flight */
        if (mine !== token) return;
        var res = pick(prod, want, id.value);
        if (!res) return;
        apply(row, p, res, mine);
      });
    });
  }

  Array.prototype.forEach.call(radios, function (r) {
    r.addEventListener('change', sync);
  });

  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1200); };
  idle(sync);
})();